import { create, StateCreator, StoreApi, UseBoundStore } from "zustand";

declare global {
	interface Window {
		__ZUSTAND_STORE_CACHE__: Record<string, unknown>;
	}
}

type StoreWrapper<T extends object> = {
	useStore: UseBoundStore<StoreApi<T>>;
	withStore: <U extends T>(storeCreator: StateCreator<U, [], []>, storeName: string) => UseBoundStore<StoreApi<U>>;
};

const createStoreWrapper = <T extends object>(): StoreWrapper<T> => {
	const getStore = <U extends T>(
		storeCreator: StateCreator<U, [], []>,
		storeName: string
	): UseBoundStore<StoreApi<U>> => {
		if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
			if (!window.__ZUSTAND_STORE_CACHE__) {
				window.__ZUSTAND_STORE_CACHE__ = {};
			}

			if (!window.__ZUSTAND_STORE_CACHE__[storeName]) {
				window.__ZUSTAND_STORE_CACHE__[storeName] = create<U>(storeCreator);
			}

			return window.__ZUSTAND_STORE_CACHE__[storeName] as UseBoundStore<StoreApi<U>>;
		}

		return create<U>(storeCreator);
	};

	return {
		useStore: getStore<T>(() => ({}) as T, "baseStore"),
		withStore: getStore
	};
};

export const wrapStore = createStoreWrapper;
